import { Box, Button, styled, TextField, Typography } from "@mui/material";

export default function XmlFeed() {
  return (
    <Box sx={{ p: 3 }}>
      <StyledContainer>
        <Box>
          <TextField
            label="Xml Feed"
            variant="outlined"
            size="small"
            sx={{ width: "100%" }}
          />
        </Box>
        <Box>
          <Button
            variant="contained"
            sx={{
              ml: "auto",
              color: "white",
              textTransform: "none",
              fontWeight: 500,
              px: 3,
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
              },
            }}
          >
            Assign New Role
          </Button>
        </Box>
      </StyledContainer>
    </Box>
  );
}

const StyledContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "center", // Center horizontally
    justifyContent: "center", // Center vertically (if applicable)
    textAlign: "center", // Optional: Center text content
    gap: theme.spacing(2),
  },
}));
